import { userStore } from "@/stores/userStore";

export const checkPermissionList = (listPermission) => {
  if (listPermission.length === 0) {
    return true;
  }

  const useUserStore = userStore();
  let allow = false;
  for (let index = 0; index < listPermission.length; index++) {
    const permission = listPermission[index];
    if (useUserStore.hasPermission(permission)) {
      allow = true;
      break;
    }
  }
  return allow;
};

export const isJatis = () => {
  const useUserStore = userStore();
  return (
    useUserStore.getClientId === parseInt(process.env.VUE_APP_JATIS_CLIENT_ID)
  );
};
